import React, { Component } from "react"
import { Button, Form, FormInput, Spinner } from "elemental-react16"
import { Loader } from "semantic-ui-react"
import serialize from "form-serialize"
import Attachments from "components/Attachments/Attachments"
import shop from "shop/shop"

import "style/Form.scss"
import prefill from "./prefill"

export default class FormCMS extends Component {
  state = {
    loading:  false,
    error:    false,
    page:     false,
    success:  false,
    redirect: false,
    files:    []
  }

  componentDidMount() {
    let slug = this.props.slug
    this.load( slug )
  }

  componentWillReceiveProps( props ) {
    let slug = props.slug
    if ( this.state.slug === slug ) return
    this.load( slug )
  }

  load( slug ) {
    this.setState( { slug, loading: true } )
    shop.form( slug )
      .then( res => {
        return res
      } )
      .then( pages => pages[ 0 ] )
      .then( ( page ) => {
        let { product } = this.props
        this.setState( { page, loading: false }, () => {
          prefill( { session: shop.session, address: shop.store.addresses.baseAddress, product } )
        } )
      } )
      .catch( error => {
        this.setState( { error } )
      } )
  }

  onSubmit = ( e ) => {
    if ( this.state.loading ) return
    const form = serialize( e.target, { hash: true } )
    //onSubmit({form})
    console.info( `submitting form`, form )
    this.setState( { form, loading: true } )
    shop.service.request( this.state.slug, form )
      .then( response => {
        if ( response.status > 200 ) {
          window.swal( "Fehler", "Bitte füllen sie alle benötigen Felder aus", "error" )
          this.setState( { response, loading: false, success: false, error: true } )
          return false
        }
        console.log( "response", response )
        this.setState( { response, loading: false, success: true } )
        if ( this.props.onSuccess ) {
          this.props.onSuccess()
        }
        console.log( `Form Response`, response )
      } )
      .catch( response => {
        this.setState( { response, loading: false, success: false, error: true } )
        window.swal( "Fehler", "Fehler bei der Übertragung: " + response, "error" )
      } )
    e.preventDefault()
    return false
  }

  render() {
    let { page, form, response, loading } = this.state

    if ( !page ) return <div>
      <Loader active/>
    </div>
    let { acf } = page || {}
    let { allowUploads } = acf
    return (
      <div className=" pt4 pl2 pr2">
        <div className="">
          <Form className="Form--cms" onSubmit={this.onSubmit}>
            {page ? <div dangerouslySetInnerHTML={{ __html: page.content.rendered }}></div> : <div>Lade Formular</div>}
            {allowUploads &&
            <div className="pt0 pb5">
              <Attachments accept="'.jpg,.jpeg,.png,.doc,.pdf,.gif'"
                           onChange={( { files } ) => {
                             this.setState( { loading: true } )
                             console.log( `uploading files`, files )
                             if ( files ) {
                               shop.service.params( files )

                                 .then( files => {
                                   console.log( `adding file`, files )
                                   this.setState( { loading: false, files } )
                                 } )
                                 .catch( error => {
                                   console.error( "Error Uploading File:", error )
                                   this.setState( { loading: false } )
                                 } )
                             }
                           }}>
                <Button>Datei auswählen</Button>
                {(this.state.files.length > 0) && <div className="">
                  {/*{this.state.files.map( file => <div key={file.id}>*/}
                  {/*  {file.id}*/}
                  {/*</div> )}*/}
                  {this.state.files.map( (file, index) => <React.Fragment key={file.id}>
                  <div className="pv3">
                    <div className={"black"}>
                      #{index+1}
                    </div>
                    <FormInput key={file.id} value={file.id} name="attachment"/>
                  </div>
                  </React.Fragment> )}
                </div>}
              </Attachments>
            </div>}

            {page.acf.showSubmit !== false && <div className="FormField">
              <Button disabled={loading} submit type="primary">{loading ? <Spinner/> : null} Absenden</Button>
            </div>}
          </Form>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/Form/FormCMS.js